import { ComponentProps, PropsWithChildren } from 'react';

import { VariantProps, cva } from 'class-variance-authority';

import { cn } from '../lib';

const variants = cva(
  'text-sm font-medium transition duration-200 leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 relative w-full md:max-w-[630px] overflow-hidden rounded-6xl  p-6',
  {
    variants: {
      variant: {
        default: 'bg-base-500',
        secondary: 'bg-base-300',
      },
      size: {
        lg: 'min-w-[630px]',
        md: 'min-w-[354px]',
        sm: 'min-w-0',
      },
    },
    defaultVariants: {
      size: 'md',
      variant: 'default',
    },
  },
);

export type ScreenCardProps = PropsWithChildren<
  VariantProps<typeof variants> & ComponentProps<'div'>
>;

export const ScreenCard = ({
  children,
  className,
  size,
  variant,
  ...props
}: ScreenCardProps) => {
  return (
    <div className={cn(variants({ size, variant }), className)} {...props}>
      {children}
    </div>
  );
};
